import React from "react"
import { useIntl } from "react-intl"
import { allowedMonths } from "../../careers/AllowedTypes"
import { renderMonthName } from "../../resume/utils/utils"
import { Dropdown } from "semantic-ui-react"
import "./DateInput.css"

/**
 * Allows a user to input a date.
 * 
 * @prop {string} idPrefix - the ids of the two inputs will be "<idPrefix>-month" and "<idPrefix>-year"
 * @prop {string} month - the selected month value as a 2-digit numerical string 
 *                        (Ex: "01", "12", etc.), or "" if no month is selected
 * @prop {string} year - the inputted year
 * @prop {function} updateMonth - runs when selected month changes
 * @prop {function} updateYear - runs when inputted year changes
 * @prop {string} className - for custom styles
 */
const DateInput = ({idPrefix="", month="", year="", updateMonth, updateYear, className=""}) => {
  const { formatMessage, locale } = useIntl()

  const monthOptions = allowedMonths.map(monthCode => ({
    key: monthCode,
    value: monthCode,
    text: renderMonthName(monthCode, locale)
  }))

  const monthValue = monthOptions.some(option => option.value === month) ? month : null

  // only allow digits in year input
  const onYearChange = (e) => updateYear(e.target.value.replace(/[^0-9]/g, ""))

  return (
    <div className={`date-input ${className}`}>
      <Dropdown
        id={`${idPrefix}-month`}
        className="month-input"
        selection
        fluid={true}
        icon='chevron down'
        options={monthOptions}
        onChange={(e, d) => updateMonth(d.value)}
        selectOnBlur={false}
        clearable={true}
        placeholder={formatMessage({ id: "experience-date-input-month-placeholder", defaultMessage: "Month" })}
        value={monthValue}
        scrolling
      />
      <input
        id={`${idPrefix}-year`}
        type="text"
        inputMode="numeric"
        className="year-input"
        maxLength={4}
        onChange={onYearChange} 
        placeholder={formatMessage({ id: "experience-dates-input-year", defaultMessage: "Year" })}
        value={year} 
      />
    </div>
  )
}

export default DateInput
